
export default {
  name: "NotificationEmpty",
  data() {
    return {}
  },
  methods: {}
}
